import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const CreateBlog = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    heading: '',
    author: '',
    content: '',
    images: [],
  });

  useEffect(() => {
    // Component mounted
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'images') {
      setFormData(prev => ({ ...prev, images: Array.from(files) }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.heading || !formData.author || !formData.content) {
      toast.error('Please fill all required fields');
      return;
    }
    if (formData.images.length === 0) {
      toast.error('Please select at least one image');
      return;
    }

    setLoading(true);
    const data = new FormData();
    data.append('heading', formData.heading);
    data.append('author', formData.author);
    data.append('content', formData.content);
    formData.images.forEach(img => data.append('images', img));

    try {
      const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
      await postRequest('blogs', data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success('Blog created successfully');
      navigate('/blogs');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to create blog');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Create New Blog</h4>
      </div>

      <form onSubmit={handleSubmit} className="form-style">
        <div className="row mx-4 mt-5">
          <div className="col-md-6 mt-2">
            <label htmlFor="heading">Heading *</label>
            <input
              type="text"
              id="heading"
              name="heading"
              className="form-control"
              value={formData.heading}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6 mt-2">
            <label htmlFor="author">Author *</label>
            <input
              type="text"
              id="author"
              name="author"
              className="form-control"
              value={formData.author}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="images">Images * (multiple)</label>
            <input
              type="file"
              id="images"
              name="images"
              className="form-control-file"
              accept="image/*"
              multiple
              onChange={handleChange}
              required
            />
            {formData.images.length > 0 && (
              <small className="text-muted">{formData.images.length} file(s) selected</small>
            )}
          </div>
          <div className="col-12 mt-2">
            <label htmlFor="content">Content *</label>
            <textarea
              id="content"
              name="content"
              className="form-control"
              rows="8"
              value={formData.content}
              onChange={handleChange}
              required
            ></textarea>
          </div>
        </div>
        <div className="mt-5 text-right mx-4">
          <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
            {loading ? 'Creating...' : 'Create Blog'}
          </button>
        </div>
      </form>


    </div>
  );
};

export default CreateBlog;